import {type FunctionalComponent, h} from '@stencil/core';
import type {SrtDocument} from '../../../../api/model/response/documents/public/SrtDocument';

export interface RenderStarsProps {
    doc: SrtDocument
    labelProvider: CallableFunction,
}

export const SrtRating: FunctionalComponent<RenderStarsProps> = (props) => {
    const clicks = props.doc.numberOfClicks ?? 0;

    return <div class="result-card__rate-result-container">
      <uiaas-search-result-rating
        document={props.doc}
        rate={props.doc.rate}
        size='small'
        displayLabel={true}
      />
      <span class='result-card__rate-result-clicks'>{props.labelProvider('clicks-last-month', 'Clicks last month:') + ' ' + clicks}</span>
    </div>;
};
